import React, { useEffect, useContext, useState, useRef, useMemo } from 'react'
import { fondDeLEcran } from "../components/ui/Formats/FormatsHelpers"
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Hidden,
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';

import Moment from 'moment'
Moment.locale('fr')

import simpleArrowIcon from '../images/simpleArrowIcon.svg';
import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"
import { useTexte, useFormeAdresse } from "../contexts/FormeAdresseContext"

import { FormatSwitch } from "./Formation"
import ScaleThumbForm from "../components/ui/Formation/ScaleThumbForm"
import VisiteGuidee from "../components/ui/VisiteGuidee"
import { useAccesCertification } from "../utils/accesCertification"
import FenetreCertificat, { BoutonVoirCertificat } from "../components/ui/Certificat/FenetreCertificat"
import { certificatDisponible } from "../components/ui/Certificat/moduleTermine"
import LigneBilan from "../components/ui/Bilan/LigneBilan"
import FenetreBilan from "../components/ui/Bilan/FenetreBilan"
import { etatDuBilan } from "../components/ui/Bilan/donneesBilan"
import { publicDeLaForme } from "../components/ui/Bilan/contenuBilan"

import MyModal from "../components/ui/MyModal"
import CircularGauge from "../components/ui/CircularGauge"

import { GLB_URL_APIS } from "../utils/APIS"
import progressionKeys from "../utils/progressionKeys"

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import nawalAbboubExpert from "../images/nawalAbboubExpert.png";
import cadrillageBGCard from "../images/cadrillageBGCard.svg"
import modulesIcon from "../images/modulesIcon.svg"
import moyenneIcon from "../images/moyenneIcon.svg"
import moyenneTempsIcon from "../images/moyenneTempsIcon.svg"
import tauxCompletionIcon from "../images/tauxCompletionIcon.svg"
import softSkillsIcon from "../images/softSkillsIcon.svg"
import cardIcon from "../images/cardIcon.svg"
import resourcesCard from "../images/resourcesCard.svg"
import closeIcon from '../images/closeIcon.svg';


/* Exporte pour etre monte seul par le test du point 3 (30/09/2026). La carte
   d'un module du programme porte les deux boutons d'entree ; monter la page
   entiere pour les eprouver demanderait de fabriquer tout un tableau de bord. */
export const SteppedCard = ({ p, setResultModal, isLast }) => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module en cours (07/10/2026). */
  const t = useTexte()
  const {
    actPlan,
    actFormation,
  } = useContext(UserContext)

  const myRefContainer = useRef(null)

  /* ⛔ 30/09/2026 — FICHE DE RETOUR DE NAWAL, POINT 3 : « Erreur survenue »
     s'affichait quand on ouvrait un module avant l'icebreaker. RIEN N'ETAIT EN
     PANNE : les deux boutons (Commencer, Reprendre) refusaient un module qui
     n'est pas le module courant, et disaient ce refus avec le message d'erreur
     passe-partout. L'apprenant croit la plateforme cassee.
     POURQUOI MAINTENANT : jusqu'au 18/09 (lot C, `utils/icebreakerGuard`)
     l'icebreaker enfermait l'apprenant, donc le tableau de bord etait
     inatteignable avant lui et ce chemin n'existait pas. En l'ouvrant — c'etait
     voulu — on a rendu atteignable un refus que personne n'avait jamais vu.
     Les deux boutons partageaient le meme bloc recopie : une seule fonction
     desormais, sinon le prochain correctif n'en touchera qu'un.
     `actPlan[0]` EST l'icebreaker : c'est deja la lecture d'`App.js` (l. 98) et
     celle du calcul des statistiques plus bas (`slice(1)`, l. 554). */
  /* ⛔ PD-17 (02/10/2026, Hicham) : L'APPRENANT SUIT L'ORDRE DE SON PLAN.
     Seul le module en cours s'ouvre. Les autres modules ouverts gardent leur
     bouton, GRISE et non cliquable, avec la raison ecrite dessous : avant, le
     bouton etait actif et son refus s'affichait « Une erreur est survenue »
     (vu par Hicham sur LAB le 02/10, SOFT SKILLS SCAN B1).
     La visite guidee (« Votre module commence ici ») vise le GROS bouton du
     module en cours (ActFormationButton), jamais une carte : quand le module
     en cours est l'icebreaker, aucune carte n'en porte (relecture du 02/10). */
  const estLeModuleEnCours = p?.id === actFormation?.id
  /* La raison suit le module EN COURS, celui que le serveur a choisi : pour
     un compte admin, App.js marque l'icebreaker fait alors que le serveur le
     sert encore (relecture de code du 02/10). */
  const icebreakerAFaire = actPlan?.[0]?.id != null && actFormation?.id === actPlan?.[0]?.id
  const ouvrirModule = () => {
    if (estLeModuleEnCours) navigate('/formation')
  }
  /* La raison s'affiche AU SURVOL du bouton grise (Hicham, 02/10 : ecrite
     dessous, « c'est cheap »). Sur telephone, ou le survol n'existe pas, un
     toucher l'ouvre et un second la ferme (l'ouverture automatique au toucher
     de MUI ne partait pas, essai WebKit 393 du 02/10). Un bouton desactive ne
     recoit aucun evenement : la bulle est posee sur une enveloppe. */
  const raisonDuVerrou = icebreakerAFaire
    ? `${t(languageValues?.dashboard?.stepper?.icebreakerDabordTitre)} ${t(languageValues?.dashboard?.stepper?.icebreakerDabordDetail)}`
    : t(languageValues?.dashboard?.stepper?.moduleVerrouille)
  const [bulleOuverte, setBulleOuverte] = useState(false)
  const verrou = (bouton) => estLeModuleEnCours ? bouton : (
    <Tooltip
      title={raisonDuVerrou} arrow placement="top"
      open={bulleOuverte} onOpen={() => setBulleOuverte(true)} onClose={() => setBulleOuverte(false)}
      disableTouchListener
    >
      <Box
        component="span" data-module-verrouille={raisonDuVerrou} tabIndex={0}
        onClick={() => setBulleOuverte((o) => !o)}
        sx={{ display:"inline-block", cursor:"not-allowed" }}
      >
        {bouton}
      </Box>
    </Tooltip>
  )

  useEffect(() => {
    //pour scroll vers la formation actuelle dans "votre programme"
    if (p?.id === actFormation?.id && myRefContainer?.current) {
      myRefContainer.current.scrollIntoView({container:"nearest"})
    }
  }, [actFormation, p, myRefContainer?.current])


  let isDone = p?.isDone

  let button = null
  if (p?.isDone === false && p?.isOpen === true && p?.progress !== false) {
    button = "resume"
  } else if (p?.isDone === false && p?.isOpen === true && p?.progress === false) {
    button = "start"
  } else if (p?.isDone && p.isIcebreaker !== true) {
    button = "results"
  }

  let status = null //completed, inProgress, passed, open, futured
  let statusText = ""
  /* ⛔ 06/10/2026 (correctif, vu par Nawal sur LAB) : UN ICEBREAKER N'EST
     JAMAIS FERME. Sa carte ne porte ni `isOpen` ni dates : le calcul general
     ci-dessous tombait dans « plan ferme », lisait une date absente (date
     invalide, ecart NaN) et concluait « Fermé ». Defaut present depuis le lot
     C-bis du 18/09, qui a rendu la carte « non faite » possible.
     Non fait : en cours (barre de progression) s'il a deja avance, sinon a
     faire, avec le libelle existant « Commence par ton icebreaker ». Jamais de
     « N jours restants » : il n'a pas de date de fermeture. */
  const avanceeIcebreaker = Number(p?.progress)
  if (p?.isDone) {
    status = "completed"
  } else if (p?.isIcebreaker === true) {
    if (p?.progress !== false && p?.progress !== null && p?.progress !== undefined && p?.progress !== ""
        && Number.isFinite(avanceeIcebreaker) && avanceeIcebreaker > 0) {
      status = "inProgress"
    } else {
      status = "open"
      statusText = t(languageValues?.dashboard?.stepper?.icebreakerDabordTitre)
    }
  } else {
    if (p?.isOpen === true) {
      //plan ouvert
      if (p?.progress === false) {
        //dispo (xxx jours restants)
        status = "open"
        if (p?.isOpenForRat === true) {
          let currentDay = Moment().startOf('day');
          var closeDate = Moment(p?.closeDateRat, "YYYY-MM-DD");
          let diffClose = parseInt(Moment.duration(closeDate.diff(currentDay)).asDays() + 1);
          if (diffClose <= 1) {
            statusText = languageValues?.dashboard?.stepper?.hoursLeft[actLanguage]
          } else {
            statusText = diffClose + languageValues?.dashboard?.stepper?.daysLeft[actLanguage]
          }
        } else {
          let currentDay = Moment().startOf('day');
          var closeDate = Moment(p?.closeDate, "YYYY-MM-DD");
          let diffClose = parseInt(Moment.duration(closeDate.diff(currentDay)).asDays()) + 1;
          if (diffClose <= 1) {
            statusText = languageValues?.dashboard?.stepper?.hoursLeft[actLanguage]
          } else {
            statusText = diffClose + languageValues?.dashboard?.stepper?.daysLeft[actLanguage]
          }
        }
      } else {
        //en cours (avec % progression)
        status = "inProgress"
      }
    } else {
      //plan fermé
      let currentDay = Moment().startOf('day');
      var normalOpenDate = Moment(p?.openDate, "YYYY-MM-DD");
      let diffNormalOpenDate = Moment.duration(normalOpenDate.diff(currentDay)).asDays();
      if (p?.enableRat === true && diffNormalOpenDate < 0) {
        let current = Moment().startOf('day');
        var openDate = Moment(p?.openDateRat, "YYYY-MM-DD");
        let diffOpen = parseInt(Moment.duration(openDate.diff(current)).asDays());
        var closeDate = Moment(p?.closeDateRat, "YYYY-MM-DD");
        let diffClose = parseInt(Moment.duration(closeDate.diff(current)).asDays());
        if (diffOpen >= 0 && diffClose >= 0) {
          //à venir
          status = "futured"
          statusText = Moment(p.openDateRat).format('DD/MM/YYYY')
        } else {
          //passé
          status = "passed"
        }
      } else {
        let current = Moment().startOf('day');
        var openDate = Moment(p?.openDate, "YYYY-MM-DD");
        let diffOpen = parseInt(Moment.duration(openDate.diff(current)).asDays());
        var closeDate = Moment(p?.closeDate, "YYYY-MM-DD");
        let diffClose = parseInt(Moment.duration(closeDate.diff(current)).asDays());
        if (diffOpen >= 0 && diffClose >= 0) {
          //à venir
          status = "futured"
          statusText = Moment(p.openDate).format('DD/MM/YYYY')
        } else {
          //passé
          status = "passed"
        }
      }
    }
  }

  return (
    <Box ref={myRefContainer} sx={{
      height:["60px", "60px", "120px", "75px"],
      display:"flex",
      flexDirection:["row", "row", "column", "row"],
      flex:1,
      justifyContent:"space-between",
      gap:"15px",
      overflow:"hidden",
    }}>
      <Box sx={{
        display:"flex",
        flexDirection:["row", "row", "column", "row"],
        gap:"15px",
        overflow:"hidden",
      }}>
        <Box sx={{
          display:["block", "block", "flex", "block"],
        }}>
          <Box sx={{
            width:"13px",
            height:"13px",
            border:"1px solid black",
            borderRadius:"50%",
            background:isDone && "black",
          }} />
          <Box sx={{
            display:isLast ? "none" : ["none", "none", "block", "none"],
            borderTop:isDone ? "1px solid black" : "none",
            backgroundImage:isDone ? "none" : "repeating-linear-gradient(to right, black 0 5px, transparent 5px 10px)", // L35
            width:"100%",
            marginTop:"6px",
            height:"1px",
          }} />
          {/* L31 : le trait s'arrete au dernier point */}
          <Box sx={{
            display:isLast ? "none" : ["block", "block", "none", "block"],
            borderLeft:isDone ? "1px solid black" : "none",
            backgroundImage:isDone ? "none" : "repeating-linear-gradient(to bottom, black 0 5px, transparent 5px 10px)", // L35
            width:"1px",
            marginLeft:"6px",
            height:"calc(100% - 13px)",
          }} />
        </Box>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:"7px",
          overflow:"hidden",
        }}>
          <Box sx={{
            color:"text.black",
            fontSize:["15px", "15px", "15px", "16px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {p?.name}
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["13px", "13px", "13px", "14px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {status === "open" &&
              statusText
            }
            {status === "futured" &&
              statusText
            }
            {status === "passed" &&
              languageValues?.dashboard?.stepper?.closed[actLanguage]
            }
            {status === "completed" &&
              languageValues?.dashboard?.stepper?.completed[actLanguage]
            }
            {status === "inProgress" &&
              <Box sx={{display:"flex", gap:"7px", alignItems:"center"}}>
                <Box sx={{width:"100px", height:"10px", border:"1px solid black", position:"relative"}}>
                  <Box sx={{position:"absolute", background:"black", height:"8px", width:p?.progress+"%"}}>
                  </Box>
                </Box>
                <Box sx={{fontSize:"13px"}}>
                  {p?.progress}%
                </Box>
              </Box>
            }
          </Box>
        </Box>
      </Box>
      <Box>
        {button === "results" &&
          <Button
            onClick={() => {
              setResultModal(p)
            }}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
              backgroundColor : "background.grey",
              border:"1px solid #EFEFEF",
              color:"text.black",
              "&:hover" : {
                color:"red",
                backgroundColor : "background.grey",
                border:"1px solid #EFEFEF",
                color:"text.subTitle",
              }
            }}
          >
            {languageValues?.dashboard?.stepper?.seeResultsBtn[actLanguage]}
          </Button>
        }
        {button === "start" && verrou(
          <Button
            data-entree-module
            onClick={ouvrirModule}
            disabled={!estLeModuleEnCours}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
            }}
          >
            {languageValues?.dashboard?.stepper?.startBtn[actLanguage]}
          </Button>
        )}
        {button === "resume" && verrou(
          <Button
            data-entree-module
            onClick={ouvrirModule}
            disabled={!estLeModuleEnCours}
            size="small"
            type="submit"
            variant="contained"
            sx={{
              fontSize:"13px !important",
              height:"32px !important",
              minHeight:"32px !important",
              whiteSpace:"noWrap",
            }}
          >
            {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
          </Button>
        )}
      </Box>
    </Box>
  )
}

const ActFormationButton = ({ setResultModal }) => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const {
    currentUser,
    actPlan,
    actFormation,
  } = useContext(UserContext)

  let status = null
  if (actFormation?.isDone) {
    status = "completed"
  } else {
    if (actFormation?.isOpen === true) {
      //plan ouvert
      if (actFormation?.progress === null || actFormation?.progress === undefined || actFormation?.progress === false) {
        //dispo
        status = "open"
      } else {
        //en cours
        status = "inProgress"
      }
    }
  }


  return (
    <>
      {status === "completed" &&
        <Button
          onClick={() => {
            setResultModal(actFormation)
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
            height:"55px !important",       // L28
            minHeight:"55px !important",    // L28
            backgroundColor : "background.grey",
            border:"1px solid #EFEFEF",
            color:"text.black",
            "&:hover" : {
              color:"red",
              backgroundColor : "background.grey",
              border:"1px solid #EFEFEF",
              color:"text.subTitle",
            }
          }}
        >
          {languageValues?.dashboard?.stepper?.seeResultsBtn[actLanguage]}
          <img src={simpleArrowIcon} style={{width:"16px", height:"13px", marginLeft:"12px"}} alt=""/> {/* L29 */}
        </Button>
      }
      {status === "inProgress" &&
        <Button
          data-visite="entree-module"
          onClick={() => {
            navigate('/formation')
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
            height:"55px !important",       // L28
            minHeight:"55px !important",    // L28
          }}
        >
          {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
          <img src={simpleArrowIcon} style={{width:"16px", height:"13px", marginLeft:"12px", filter:"brightness(0) invert(1)"}} alt=""/> {/* L29 */}
        </Button>
      }
      {status === "open" &&
        <Button
          data-visite="entree-module"
          onClick={() => {
            navigate('/formation')
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            width:["100%", "100%", "unset", "unset"],
            fontSize:"16px",
            whiteSpace:"nowrap",
            paddingLeft:"40px",
            paddingRight:"40px",
            height:"55px !important",       // L28
            minHeight:"55px !important",    // L28
          }}
        >
          {languageValues?.dashboard?.stepper?.startBtn[actLanguage]}
          <img src={simpleArrowIcon} style={{width:"16px", height:"13px", marginLeft:"12px", filter:"brightness(0) invert(1)"}} alt=""/> {/* L29 */}
        </Button>
      }
    </>
  )
}

const CardContainer = ({icon, title, value, dataLoaded, unit}) => {
  return (
    <Box
      sx={{
        width:
          [
            "calc((100% / 2) - (((2 - 1) / 2) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 20px))",
          ],
        height: ["102px", "130px", "130px", "145px"],
        minHeight: ["102px", "130px", "130px", "145px"],
        border:"1px solid #E7E7E7",
        backgroundImage:`url(${cadrillageBGCard})`,
        backgroundRepeat:"no-repeat",
        backgroundPosition:"right 5px bottom 5px",
        backgroundColor:"white",
      }}
    >
      <Box sx={{
        width:"100%",
        height:"100%",
        background: "linear-gradient(130deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 45%, rgba(255, 255, 255, 0.55) 95%, rgba(255, 255, 255, 0.45) 100%)", // L41
      }}>
        {dataLoaded ? (
          <Box sx={{padding:["10px", "15px", "15px", "15px"], display: "flex", flexDirection:"column"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center", marginBottom:["7px", "12px", "12px", "8px"]}}>
              <Box
                sx={{
                  width:["20px", "35px", "35px", "40px"],
                  minWidth:["20px", "35px", "35px", "40px"],
                }}
              >
                <img src={icon} style={{width:"100%"}}/>
              </Box>
              <Box sx={{fontSize:["14px", "16px", "16px", "18px"], color:"text.subTitle", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
                {title}
              </Box>
            </Box>
            <Box sx={{fontSize:["30px", "41px", "41px", "50px"] /* L40 */, color:"black", display:"flex", alignItems:"flex-end", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
              {value}
              {unit &&
                <Box sx={{fontSize:["26px", "22px", "22px", "30px"] /* L40 */, color:"text.subTitle", paddingBottom:["3px","5px","5px","5px"], whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden"}}>{unit}</Box>
              }
            </Box>
          </Box>
        ) : (
          <Box sx={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="30px" sx={{'color': 'black'}} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

/* ⛔ LES TEXTES DE LA VISITE GUIDEE.
   Ecrits dans la voix de Rising Up : on explique ce que la personne peut
   FAIRE, pas ce que la plateforme sait faire. Pas de superlatif, pas de
   « bienvenue dans votre espace », pas de promesse. Trois etapes : au-dela,
   personne ne lit.
   ⚠️ A relire par Nawal avant mise en ligne. C'est sa voix, pas la mienne.
   07/10/2026 : les textes vivent dans le dictionnaire (`visiteApprenant`),
   au tu ou au vous selon la cible du module en cours ; seules les cibles de
   chaque etape restent ici. */
export const etapesApprenant = (t, v) => [
  {
    cible: '[data-visite="entree-module"]',
    titre: t(v?.moduleTitre),
    texte: t(v?.moduleTexte),
  },
  {
    cible: '[data-visite="menu-myCertification"]',
    titre: t(v?.resultatsTitre),
    texte: t(v?.resultatsTexte),
  },
  {
    cible: '[data-visite="menu-dashboard"]',
    titre: t(v?.departTitre),
    texte: t(v?.departTexte),
    terminer: t(v?.terminer),
  },
]

const Dashboard = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module en cours (07/10/2026). */
  const t = useTexte()
  /* Memes etapes tant que la langue et la forme ne changent pas : la visite
     relance son calcul quand la liste change (VisiteGuidee, dependance `etapes`). */
  const etapesVisite = useMemo(() => etapesApprenant(t, languageValues?.visiteApprenant), [t, languageValues])
  /* ⛔ BILAN SOFT SKILLS (07/10/2026, etape 2, Nawal) : derniere etape de
     « Votre programme », pour un apprenant dont le plan mesure des
     competences du referentiel ; verrouillee jusqu'a la fin du parcours.
     Donnees et regles : components/ui/Bilan/donneesBilan.js. Le public (tu =
     etudiant, vous = professionnel) suit la forme d'adresse publiee. */
  const formeAdresse = useFormeAdresse()
  const {
    currentUser,
    actPlan,
    actFormation,
    actIndex,
    lastDoneIndex,
  } = useContext(UserContext)
  const bilan = useMemo(() => etatDuBilan({ currentUser, actPlan, public: publicDeLaForme(formeAdresse) }), [currentUser, actPlan, formeAdresse])
  const [bilanOuvert, setBilanOuvert] = useState(false)

  const [myStats, setMyStats] = useState({})

  /* 06/10/2026 : la visite attend de savoir si l'onglet « Ma certification »
     est ouvert. Verrouille, il perd sa cible et l'etape est sautee ; sans
     cette attente, la visite pouvait s'ouvrir avant le verdict et compter
     une etape qui apparait ou disparait sous les yeux. */
  const statutCertif = useAccesCertification()

  /* ⛔ 06/10/2026 (Nawal) : si l'ecran ou en est l'apprenant est une VIDEO, la
     vignette du module en cours montre sa vignette, en plein cadre (voir
     `videoCouverture` dans ScaleThumbForm). Le cadre, le titre, la description,
     l'intervenant, le bouton et les espacements ne changent pas. */
  const ecranDeLaVignette = actFormation?.chapitre?.[lastDoneIndex?.chapitre]?.partie?.[lastDoneIndex?.partie]?.sequence?.[lastDoneIndex?.sequence]
  const videoDeLaVignette = ecranDeLaVignette?.type === "Video" && ecranDeLaVignette?.playbackId ? ecranDeLaVignette.playbackId : null

  useEffect(() => {
    if (currentUser && actPlan && actFormation) {
      let newStats = {}
      let actPlanWithoutIcebreaker = [...actPlan]?.slice(1)
      newStats.nbrModules = actPlanWithoutIcebreaker?.length || "-"
      if (actPlanWithoutIcebreaker?.length > 0) {
        let nbrSoftSkills = 0
        let totalTempsPassé = 0
        let nbrModulesDone = 0
        let totalScoreModulesDone = 0
        let nbrModulesMoyGroupe = 0
        let totalModulesMoyGroupe = 0

        let findStartProgression = false
        let findEndProgression = false

        actPlanWithoutIcebreaker.forEach((p) => {
          //nbr softSkills
          if (p?.softSkillsFromContent) {
            nbrSoftSkills += p?.softSkillsFromContent?.length
          }

          //moyenne temps passé
          if (p?.timing >= 0) {
            totalTempsPassé += p?.timing
          }

          //moyenne des modules terminées + progression
          if (p?.isDone && p?.resultFin) {

            //moyenne modules terminées
            nbrModulesDone += 1
            // 07/10/2026 (Claude, accord d'Hicham) : un score de module vide (rien de
            // coche « oui », fiche scoring de Nawal) prend le score global, au lieu de 0 %
            if (Number.isFinite(p?.resultFin?.glbMaster?.score)) {
              totalScoreModulesDone += p?.resultFin?.glbMaster?.score
            } else {
              totalScoreModulesDone += p?.resultFin?.master?.score || 0
            }

            //progression
            if (progressionKeys?.start && progressionKeys?.end) {
              let findStart = Object.keys(p?.resultFin).find((el) => el.includes(progressionKeys?.start))
              if (findStart) {
                findStartProgression = p?.resultFin?.[findStart]   // M3
              }
              let findEnd = Object.keys(p?.resultFin).find((el) => el.includes(progressionKeys?.end))
              if (findEnd) {
                findEndProgression = p?.resultFin?.[findEnd]   // M3
              }
            }
          }

          //moyenne groupe
          if (p?.moyContentForThisGroupe >= 0) {
            nbrModulesMoyGroupe += 1
            totalModulesMoyGroupe += p?.moyContentForThisGroupe
          }
        })

        newStats.nbrSoftSkills = nbrSoftSkills
        newStats.moyTempsPasse = parseInt(totalTempsPassé/newStats.nbrModules)
        //moyenne modules terminées
        newStats.nbrModulesDone = nbrModulesDone
        if (newStats?.nbrModulesDone > 0) {
          newStats.moyModulesDone = parseInt(totalScoreModulesDone/newStats.nbrModulesDone)
        } else {
          newStats.moyModulesDone = "-"
        }
        //progression
        if (findStartProgression && findEndProgression) {
          newStats.progression = parseInt(findEndProgression?.score - findStartProgression?.score)
        }
        //moyenne groupe
        newStats.nbrModulesMoyGroupe = nbrModulesMoyGroupe
        if (newStats?.nbrModulesMoyGroupe > 0) {
          newStats.moyGroupe = parseInt(totalModulesMoyGroupe/newStats.nbrModulesMoyGroupe)
        } else {
          newStats.moyGroupe = "-"
        }
      }

      setMyStats(newStats)
    } else {
      setMyStats({})
    }
  }, [currentUser, actPlan, actFormation])


  const [resultModal, setResultModal] = useState(false)
  const [resultModalName, setResultModalName] = useState("")
  /* ⛔ CERTIFICAT DE REUSSITE (06/10/2026, etape 2, Nawal) : « Voir mon
     certificat » dans « Mon résultat », au niveau du module, pour un module
     TERMINE (isDone && progress === 100) ; jamais pour l'icebreaker (voir
     Certificat/moduleTermine.js). Le nom est celui de la ligne du plan. */
  const [certificatOuvert, setCertificatOuvert] = useState(false)
  const avecCertificat = resultModal !== false
    && certificatDisponible({ module: resultModal, actPlan, prenomNom: currentUser?.name })
  /* une autre fenetre de resultat (ou sa fermeture) referme le certificat :
     sinon il se rouvrirait tout seul au module suivant */
  useEffect(() => { setCertificatOuvert(false) }, [resultModal])
  const [resultModalValue, setResultModalValue] = useState(0)
  const [resultModalText, setResultModalText] = useState("")
  useEffect(() => {
    if (resultModal !== false) {
      setResultModalName(resultModal?.name)
      let resultFin = null
      try {
        if (typeof resultModal?.resultFin === "string") {
          resultFin = JSON.parse(resultModal?.resultFin)
        } else if (typeof resultModal?.resultFin === "object") {
          resultFin = resultModal?.resultFin
        }
      } catch(e) { console.log(e) }
      if (resultFin) {
        let scoreToTake = 0
        let chooseCat = ""
        if (resultFin?.glbMaster?.score !== undefined && resultFin?.glbMaster?.score !== null) {
          scoreToTake = resultFin?.glbMaster?.score
          chooseCat = "glbMaster"
        } else if (resultFin?.master?.score !== undefined && resultFin?.master?.score !== null) {
          scoreToTake = resultFin?.master?.score
          chooseCat = "master"
        }
        if (chooseCat !== "") {
          setResultModalValue(scoreToTake)
          //on va cercher dans les seuils pour trouver le texte
          let findInSeuils = resultModal?.seuils?.find((el) => el.key === chooseCat)
          if (findInSeuils) {
            let newText = ""
            for (let i=findInSeuils?.value?.seuil?.length-1; i>=0; i--) {
              if (parseInt(scoreToTake) >= findInSeuils?.value?.seuil[i]?.seuil) {
                newText = findInSeuils?.value?.seuil[i]?.text
              }
            }
            setResultModalText(newText)
          } else {
            setResultModalText("")
          }
        } else {
          setResultModalValue(0)
          setResultModalText("")
        }
      } else {
        setResultModalValue(0)
        setResultModalText("")
      }
    } else {
      setResultModalValue(0)
      setResultModalText("")
    }
  }, [resultModal])



  return (
    <>
      <Helmet>
        <title>Dashboard | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:["20px", "50px", "50px", "80px"],
            backgroundColor:"background.grey",
          }}
        >
          {/* TOP */}
          <Box sx={{
            display:"flex",
            flexDirection:["column", "row"],
            justifyContent:"space-between",
            paddingBottom:["30px","40px","40px","50px"],
            rowGap:"15px",
            columnGap:"30px",
            alignItems:["flex-start","center"],
            overflow:"hidden",
          }}>
            <Box sx={{
              overflow:"hidden",
              maxWidth:"100%"
            }}>
              <Box sx={{
                fontSize:["26px","36px","36px","42px"],
                color:"text.black",
                paddingTop:["10px", "12px", "12px", "15px"],
                paddingBottom:["10px", "12px", "12px", "15px"],
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {languageValues?.adminDashboard?.homeWelcome[actLanguage]}{currentUser?.name?.split(" ")[0]},
              </Box>
              <Box sx={{
                fontSize:["15px","19px","19px","22px"],
                color:"text.black",
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {t(languageValues?.dashboard?.bienvenueSousTitre)}
              </Box>
            </Box>
            {currentUser?.groupes[0]?.img &&
              <Box sx={{
                display:"flex",
                flexDirection:["row", "column"],
                rowGap:"15px",
                columnGap:"15px",
                overflow:"hidden",
                maxWidth:"100%",
              }}>
                {/* POINT 62 : le garde `groupes[0]?.img` ne protège que du logo
                    NON RENSEIGNÉ. Quand le nom est en base mais que le fichier
                    manque côté serveur (404), le navigateur affiche son icône
                    d'image cassée. Même repli que MyCertif : on retire l'élément
                    dès qu'il échoue à charger. */}
                <Hidden smDown>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} alt="" onError={(e) => { e.currentTarget.style.display = "none" }} style={{maxHeight:"60px", objectFit:"contain"}} />
                </Hidden>
                <Hidden smUp>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} alt="" onError={(e) => { e.currentTarget.style.display = "none" }} style={{maxHeight:"50px", objectFit:"contain"}} />
                </Hidden>
              </Box>
            }
          </Box>
          {/* END TOP */}

          {/* ACT FORMATION & PLANS */}
          <Box sx={{
            paddingBottom:["25px","30px","30px","40px"],
            display:"flex",
            flexDirection:["column", "column", "column", "row"],
            columnGap:"60px", // L30
            rowGap:["15px", "20px"],
            maxHeight:["unset", "unset", "unset", "407px"],
            overflow:"hidden",
          }}>
            <Box sx={{
              flex:0.65,
              border:"1px solid #E7E7E7",
              background:"white",
              padding:["10px", "15px", "15px", "20px"],
              display:"flex",
              flexDirection:["column", "column", "column", "row"],
              columnGap:"30px",
              rowGap:["15px", "20px"],
              overflow:"hidden",
            }}>
              <Box sx={{
                flex:0.6,
                height:"325px",
                minHeight:["200px", "380px", "380px", "325px"],
                overflow:"hidden",
                display:"flex",
                justifyContent:"center",
                alignItems:"center",
              }}>
                <Box sx={{
                  aspectRatio:"1.5",
                  overflow:"hidden",
                  maxHeight:"100%"
                }}>
                  <ScaleThumbForm videoCouverture={videoDeLaVignette} fond={fondDeLEcran(actFormation?.chapitre[lastDoneIndex?.chapitre]?.partie[lastDoneIndex?.partie]?.sequence[lastDoneIndex?.sequence])} onClick={actFormation?.isOpen ? () => { navigate('/formation') } : null}>
                    <FormatSwitch
                      actFormation={actFormation}
                      format={actFormation?.chapitre[lastDoneIndex?.chapitre]?.partie[lastDoneIndex?.partie]?.sequence[lastDoneIndex?.sequence]}
                      actIndex={{chapitre : lastDoneIndex?.chapitre, partie : lastDoneIndex?.partie, sequence : lastDoneIndex?.sequence}}
                      actPlan={actPlan}
                      onlyContent
                    />
                  </ScaleThumbForm>
                </Box>
              </Box>
              <Box sx={{
                flex:0.4,
                overflow:"hidden",
                display:"flex",
                columnGap:"20px",
                flexDirection:["column", "column", "row", "column"],
                justifyContent:["center", "center", "space-between", "center"],
                padding:["10px", "5px 10px", "15px 20px", "0px"],
              }}>
                <Box sx={{overflow:"hidden"}}>
                  {/* ⛔ 06/10/2026 (Nawal) : TITRE ET DESCRIPTION PLUS PETITS, DANS
                      LEURS EMPLACEMENTS D'AVANT. Les hauteurs sont FIGEES sur
                      celles mesurees de la version publiee (titre 23/23/29/33 px,
                      description 36/36/39/41 px, filet compris) : le filet,
                      l'intervenant et le bouton ne bougent pas d'un pixel, quelle
                      que soit la longueur des textes.
                      Titre : 24 px (22 au palier md, 20 en pile), une ligne, « … »
                      au-dela. Description : 15 px (14 au telephone) ; deux lignes
                      la ou l'emplacement les tient (ordinateur, palier md), une
                      seule en pile (34 px de place, trop peu pour deux lignes
                      lisibles), coupure « … » au-dela. */}
                  <Box sx={{
                    fontSize:["20px", "20px", "22px", "24px"],
                    lineHeight:["23px", "23px", "29px", "33px"],
                    height:["23px", "23px", "29px", "33px"],
                    color:"text.black",
                    marginBottom:"10px",
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    overflow:"hidden",
                  }}>
                    {actFormation?.name}
                  </Box>
                  <Box sx={{
                    fontSize:["14px", "15px", "15px", "15px"],
                    color:"text.black",
                    boxSizing:"border-box",
                    height:["36px", "36px", "39px", "41px"],
                    lineHeight:["15px", "15px", "19.5px", "19.5px"],
                    display:["block", "block", "-webkit-box", "-webkit-box"],
                    WebkitBoxOrient:"vertical",
                    WebkitLineClamp:["unset", "unset", 2, 2],
                    whiteSpace:["nowrap", "nowrap", "normal", "normal"],
                    textOverflow:"ellipsis",
                    overflow:"hidden",
                    paddingBottom:["20px", "20px", "0px", "1px"],
                    borderBottom:["1px solid #EFEFEF", "1px solid #EFEFEF", "0", "1px solid #EFEFEF"],
                  }}>
                    {actFormation?.description}
                  </Box>
                  <Box sx={{
                    display:["none", "none", "block", "none"],
                    marginTop:"30px",
                  }}>
                    <ActFormationButton setResultModal={setResultModal}/>
                  </Box>
                </Box>
                <Box sx={{
                  display:"flex",
                  gap:"12px",
                  marginTop:["20px", "20px", "0px", "20px"],
                }}>
                  <Box sx={{
                    width:["40px", "40px", "50px", "50px"],
                    height:["40px", "40px", "50px", "50px"],
                  }}>
                    <img src={nawalAbboubExpert} style={{width:"100%", height:"100%"}} />
                  </Box>
                  <Box sx={{
                    display:"flex",
                    flexDirection:"column",
                    gap:"5px",
                    justifyContent:"center",
                  }}>
                    <Box sx={{
                      fontSize:"15px",
                      color:"text.black",
                      whiteSpace:"noWrap",
                    }}>
                      Nawal Abboub
                    </Box>
                    <Box sx={{
                      fontSize:"13px",
                      color:"text.subTitle",
                      whiteSpace:"noWrap",
                    }}>
                      {languageValues?.dashboard?.expertDesc[actLanguage]}
                    </Box>
                  </Box>
                </Box>
                <Box sx={{
                  display:["block", "block", "none", "block"],
                  marginTop:"40px",
                }}>
                  <ActFormationButton setResultModal={setResultModal}/>
                </Box>
              </Box>
            </Box>
            <Box sx={{
              flex:0.35,
              border:"1px solid #E7E7E7",
              background:"white",
              padding:["15px 10px", "20px 15px", "30px 20px", "30px 30px"], // L33
              paddingBottom:["0 !important", "0 !important", "30px !important", "0 !important"],
              overflow:"hidden",
            }}>
              <Box sx={{
                color:"text.black",
                fontSize:["22px", "24px", "24px", "26px"],
                paddingBottom:["10px", "15px", "30px", "25px"], // L32
              }}>
                {t(languageValues?.dashboard?.yourProgram)}
              </Box>
              <Box sx={{
                overflowX:"hidden",
                overflowY:"auto",
                maxHeight:["240px", "240px", "190px", "calc(100% - 40px)"],
                paddingLeft:["10px", "0px", "0px", "10px"],
                paddingRight:["10px", "0px", "0px", "10px"],
                display:["block", "block", "flex", "block"]
              }}>
                {/* Lot C-bis (18/09) : l'etat de la carte Icebreaker suit le vrai plan
                    (actPlan[0]), pas une constante. Depuis que le dashboard est
                    accessible sans avoir termine l'icebreaker (lot C), un « isDone:true »
                    fige affichait faussement l'etape comme terminee. */}
                {/* 06/10/2026 : `progress` passe aussi, pour afficher « en cours »
                    plutot que « a faire » quand il a deja avance (voir SteppedCard). */}
                {/* 07/10/2026 : avec la ligne du bilan, ni l'icebreaker ni le dernier
                    module ne sont la derniere etape : leur trait relie la suivante */}
                <SteppedCard p={{name : "Icebreaker", isDone: actPlan?.[0]?.isDone === true, isIcebreaker:true, progress: actPlan?.[0]?.progress}} isLast={!(actPlan?.length > 1) && !bilan.visible}/>
                {actPlan?.slice(1)?.map((p, key, arr) => {
                  return (
                    <SteppedCard key={key} p={p} setResultModal={setResultModal} isLast={key === arr.length - 1 && !bilan.visible}/>
                  )
                })}
                {bilan.visible &&
                  <LigneBilan etat={bilan.etat} onVoir={() => setBilanOuvert(true)} />
                }
              </Box>
            </Box>
          </Box>
          {/* END ACT FORMATION & PLANS */}

          {/* MY STATS */}
          <Box sx={{
            display:"flex",
            gap:"60px", // L39
            alignItems:"stretch", // L38
            paddingTop:"10px",
          }}>
            <Hidden lgDown>
              <Box sx={{
                width:"400px",       // L36
                flex:"0 0 400px",    // L36
                display:"flex",
                flexDirection:"column",
                gap:"30px",
              }}>
                <Box sx={{
                  fontSize:["22px", "22px", "26px", "32px"],
                  color:"text.black",
                }}>
                  {languageValues?.dashboard?.resources[actLanguage]}
                </Box>
                <Box
                  sx={{
                    border:"1px solid #E7E7E7",
                    background:"white",
                    flex:1,
                    padding:"25px",
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                    justifyContent:"center",
                    gap:"10px"
                  }}
                >
                  <img src={resourcesCard} style={{width:"100%", maxWidth:"310px", marginBottom:"20px"}}/>
                  <Box sx={{
                    color:"text.black",
                    fontSize:"26px",
                    width:"100%",
                  }}>
                    {languageValues?.dashboard?.resourcesCard?.title[actLanguage]}
                  </Box>
                  {/* L37 : le sous-titre existait dans LanguageContext mais n'etait pas affiche */}
                  <Box sx={{
                    color:"text.subTitle",
                    fontSize:"16px",
                    width:"100%",
                  }}>
                    {t(languageValues?.dashboard?.resourcesCard?.subTitle)}
                  </Box>
                  <Box sx={{display:"flex", width:"100%", marginTop:"10px", justifyContent:"space-around", flexWrap:"wrap", columnGap:"20px"}}>
                    <Button
                      variant="text"
                      onClick={() => {
                        window.open("https://www.risinguparis.com/soft-skills", '_blank').focus();
                      }}
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:0,
                        fontSize:"18px",
                        whiteSpace:"noWrap",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        }
                      }}
                    >
                      {languageValues?.dashboard?.resourcesCard?.dictionary[actLanguage]}
                      <KeyboardArrowDownIcon style={{transform:"rotate(-90deg)",marginBottom:"2px"}}/>
                    </Button>
                    <Button
                      variant="text"
                      onClick={() => {
                        window.open("https://www.risinguparis.com/blog", '_blank').focus();
                      }}
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:0,
                        fontSize:"18px",
                        whiteSpace:"noWrap",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        }
                      }}
                    >
                      Blog
                      <KeyboardArrowDownIcon style={{transform:"rotate(-90deg)",marginBottom:"2px"}}/>
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Hidden>
            <Box sx={{
              flex:1, // L36 : "mes stats" en stretch
              display:"flex",
              flexDirection:"column",
              gap:["15px", "20px", "20px", "30px"]
            }}>
              <Box sx={{
                fontSize:["22px", "22px", "26px", "32px"],
                color:"text.black",
              }}>
                {languageValues?.dashboard?.myStats[actLanguage]}
              </Box>
              <Box sx={{display:"flex", flexWrap:"wrap", gap:["15px","15px","15px","20px"]}}>
                <CardContainer
                  title={languageValues?.dashboard?.cards?.modulesAverage[actLanguage]}
                  value={myStats?.moyModulesDone!==undefined?myStats.moyModulesDone:"-"} icon={cardIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.modules[actLanguage]}
                  value={myStats?.nbrModules!==undefined?myStats.nbrModules:"-"} icon={modulesIcon} dataLoaded={true}
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.progression[actLanguage]}
                  value={myStats?.progression!==undefined?myStats.progression:"-"} icon={tauxCompletionIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.groupeAverage[actLanguage]}
                  value={myStats?.moyGroupe!==undefined?myStats.moyGroupe:"-"} icon={moyenneIcon} dataLoaded={true} unit="&nbsp;/100"
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.softSkills[actLanguage]}
                  value={myStats?.nbrSoftSkills!==undefined?myStats.nbrSoftSkills:"-"} icon={softSkillsIcon} dataLoaded={true}
                />
                <CardContainer
                  title={languageValues?.dashboard?.cards?.time[actLanguage]}
                  value={myStats?.moyTempsPasse!==undefined?myStats.moyTempsPasse:"-"} icon={moyenneTempsIcon} dataLoaded={true} unit="&nbsp;MIN"
                />
              </Box>
            </Box>
          </Box>
          {/* END MY STATS */}


          {/* LB MY RESULTS */}
            <MyModal
              isOpen={resultModal!==false}
              maxWidth="md"
              onClose={() => { setResultModal(false) }}
              fullCustom
              forMyResults
            >
              <Box>
                <Box sx={{
                  display:"flex",
                  justifyContent:"flex-end"
                }}>
                  <img
                    src={closeIcon}
                    style={{width:"17px", height:"17px", cursor:"pointer"}}
                    onClick={() => { setResultModal(false) }}
                  />
                </Box>

                <Box sx={{
                  display:"flex",
                  flexDirection:["column", "column", "row", "row"],
                  justifyContent:"space-between",
                  alignItems:["center", "center", "stretch", "stretch"],
                  columnGap:"110px",
                  rowGap:"35px",
                  padding:"10px 20px"
                }}>
                  <Box sx={{
                    order:[1, 1, 0, 0],
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"space-between"
                  }}>
                    <Box sx={{
                      textAlign:["center", "center", "left", "left"],
                    }}>
                      <Box sx={{
                        color:"text.black",
                        fontSize:"18px",
                      }}>
                        {resultModalName}
                      </Box>
                      <Box sx={{
                        color:"text.black",
                        fontSize:["32px", "36px", "42px", "42px"],
                        marginTop:"5px",
                        marginBottom:["20px", "30px", "0", "0"]
                      }}>
                        {languageValues?.dashboard?.resultModal?.title[actLanguage]}
                      </Box>
                    </Box>
                    <Box sx={{
                      color:"text.subTitle",
                      fontSize:["15px", "16px", "18px", "18px"],
                      maxWidth:"500px",
                      textAlign:["center", "center", "left", "left"],
                    }}>
                      {resultModalText}
                      {avecCertificat &&
                        <Box sx={{ marginTop:["20px", "25px", "30px", "30px"], display:"flex", justifyContent:["center", "center", "flex-start", "flex-start"] }}>
                          <BoutonVoirCertificat onClick={() => setCertificatOuvert(true)} />
                        </Box>
                      }
                    </Box>
                  </Box>
                  <Box>
                    <Box sx={{
                      width:["250px", "275px", "32px", "320px"],
                      height:["250px", "275px", "320px", "320px"],
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"center"
                    }}>
                      <Hidden smDown>
                        <CircularGauge value={resultModalValue} size={275} />
                      </Hidden>
                      <Hidden smUp>
                        <CircularGauge value={resultModalValue} size={250} />
                      </Hidden>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </MyModal>
            {bilan.etat === "disponible" &&
              <FenetreBilan
                ouverte={bilanOuvert}
                onFermer={() => setBilanOuvert(false)}
                prenomNom={bilan.donnees.prenomNom}
                nomParcours={bilan.donnees.nomParcours}
                contenu={bilan.donnees.contenu}
                dateDelivrance={bilan.donnees.dateDelivrance}
              />
            }
            {avecCertificat &&
              <FenetreCertificat
                ouverte={certificatOuvert}
                onFermer={() => setCertificatOuvert(false)}
                prenomNom={currentUser?.name}
                nomModule={resultModal?.name}
              />
            }
          {/* END LB MY RESULTS */}
        </Box>
      </Box>

      {/* La visite ne s'ouvre qu'une fois par personne et par navigateur, et
          seulement si ses cibles existent : le tableau de bord n'affiche pas
          les memes boutons selon l'avancement. */}
      <VisiteGuidee
        cle={currentUser?.id ? ("risingup.visite.apprenant." + currentUser.id) : null}
        etapes={etapesVisite}
        actif={statutCertif !== "chargement"}
      />
    </>
  )
};

export default Dashboard;
